import { render, staticRenderFns } from "./SpringboardPage.vue?vue&type=template&id=b4c705b8"
import script from "./SpringboardPage.vue?vue&type=script&lang=js"
export * from "./SpringboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports